<div
    role="group"
    class="example-ssn-input-container"
    [formGroup]="parts"
    [attr.aria-labelledby]="_formField.getLabelId()"
    (focusin)="onFocusIn($event)"
    (focusout)="onFocusOut($event)"
>
    <input
        class="example-ssn-input-element"
        formControlName="area"
        size="3"
        maxLength="3"
        aria-label="Area number"
        (input)="_handleInput(parts.controls.area, group)"
        inputmode="numeric"
        #area
    />
    <span class="example-ssn-input-spacer">&ndash;</span>
    <input
        class="example-ssn-input-element"
        formControlName="group"
        maxLength="2"
        size="2"
        aria-label="Group number"
        (input)="_handleInput(parts.controls.group, serial)"
        (keyup.backspace)="autoFocusPrev(parts.controls.group, area)"
        _handleInput
        inputmode="numeric"
        #group
    />
    <span class="example-ssn-input-spacer">&ndash;</span>
    <input
        class="example-ssn-input-element"
        formControlName="serial"
        maxLength="4"
        size="4"
        aria-label="Serial number"
        (input)="_handleInput(parts.controls.serial)"
        (keyup.backspace)="autoFocusPrev(parts.controls.serial, group)"
        inputmode="numeric"
        #serial
    />
</div>
